import { t } from '@lingui/core/macro';
import { BackendErrorText, getBackendErrorText } from 'shared/errors';

/**
 * Отказ «превышен лимит заявок на команду» (`ApplicationLimitExceededException` бэкенда).
 *
 * Кода у отказа нет (объявленный `7015` бэкенд не присылает), поэтому он узнаётся правилом «по
 * тексту» реестра (`shared/errors`), а не здесь.
 */
export function isApplicationLimitExceeded(error: unknown): boolean {
  return getBackendErrorText(error) === BackendErrorText.APPLICATION_LIMIT_EXCEEDED;
}

/**
 * Текст отказа. Лимит — `applicationMaxPlayers` из настроек турнира, а не число из английского
 * текста ошибки: бэкенд подставляет туда то же значение (`UpsertChampionshipApplicationHandler.php:281`).
 *
 * `team` — заявляли команду целиком: заявляются все её игроки, и пояснение длиннее.
 */
export function getApplicationLimitMessage(limit: number | null | undefined, scope: 'player' | 'team'): string {
  if (limit === null || limit === undefined) {
    return scope === 'team'
      ? t`Превышен лимит заявок на участие в турнире. При заявлении команды все игроки, находящиеся в ней, будут заявлены. Для заявления конкретных игроков перейдите в заявку команды, кликнув на неё.`
      : t`Превышен лимит заявок на участие в турнире.`;
  }

  return scope === 'team'
    ? t`Превышен лимит заявок на участие в турнире. По условиям доступно заявок на команду: ${limit}. При заявлении команды все игроки, находящиеся в ней, будут заявлены. Вероятно кол-во игроков в команде превышает допустимое кол-во заявок установленное в условиях турнира. Для заявления конкретных игроков перейдите в заявку команды, кликнув на неё.`
    : t`Превышен лимит заявок на участие в турнире. По условиям доступно заявок на команду: ${limit}`;
}
